export default __webpack_public_path__ + "static/media/withdraw-epoint-step6.c0504a4a.png";